/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        const LOG_CATEGORY = "WPT.Navigation.Home";
        const DEFAULT_TEMPLATE = 1;
        class HomeNavigationHandler extends Navigation.HomeNavigationHandlerBaseClass {
            constructor(core, navigation) {
                super(core, navigation);
                this._oldPasswordInput = null;
                this._newPasswordInput = null;
                this._reenterPasswordInput = null;
                this._changeBtn = null;
                this._changePwProcessing = null;
                this.startNavigation = () => {
                    this._log.info("HomeNavigationHandler.startNavigation()");
                    this.HomeView.innerHTML = "";
                    let selectedApp = this._core.Config.getApplicationConfig();
                    if (selectedApp.hasOwnProperty('CustomHomeTemplate') && (selectedApp.CustomHomeTemplate != null)) {
                        if (typeof selectedApp.CustomHomeTemplate !== 'object') {
                            if (selectedApp.CustomHomeTemplate.trim().length > 0) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("using custom home template: " + selectedApp.CustomHomeTemplate);
                                }
                                this._core.Loader.getUnversionedHTML('custom/layouts/home/' + selectedApp.CustomHomeTemplate + '.html', this._prepareLayout, this._core.Helper.missingHtmlErrorCallback);
                            }
                        }
                        else {
                            // Must be a remote config specification
                            let remoteSpec = {
                                Instance: selectedApp.CustomHomeTemplate.Instance,
                                FileType: 'VIEW-LAYOUT',
                                Id: selectedApp.CustomHomeTemplate.Id
                            };
                            this._core.Loader.retrieveConfigData(remoteSpec, this._receiveRemoteViewLayout, this._core.Helper.missingHtmlErrorCallback);
                        }
                    }
                    else {
                        let template = null;
                        if (selectedApp.hasOwnProperty('HomeTemplate')) {
                            template = selectedApp.HomeTemplate;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using home template: " + template);
                            }
                        }
                        if (template == null || template == undefined) {
                            template = DEFAULT_TEMPLATE;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using default home template: " + template);
                            }
                        }
                        this._core.Loader.getVersionedHTML('layouts/home/template' + template + '.html', this._prepareLayout, this._core.Helper.missingHtmlErrorCallback);
                    }
                };
                this._receiveRemoteViewLayout = (response) => {
                    this._log.info("HomeNavigationHandler._receiveRemoteSpecificAppConfig()");
                    this._prepareLayout(response.ContentText);
                };
                this.resetNavigation = () => {
                    this._log.info("HomeNavigationHandler.resetNavigation()");
                    this._core.Widgets.clearHomepageWidgets();
                    this.HomeView.innerHTML = "";
                };
                this._prepareLayout = (htmlData) => {
                    this._log.info("HomeNavigationHandler._prepareLayout()");
                    this.HomeView.innerHTML = htmlData;
                    this._core.Widgets.displayHomepageWidgets();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("HomeNavigationHandler::constructor");
                this.HomeView = navigation.MainPage.querySelector('#HomeView');
            }
        }
        Navigation.HomeNavigationHandler = HomeNavigationHandler;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
